@if (isLoggedIn()) {
  <div id="main-wrapper">
    <navBarComponent></navBarComponent>
    <headerComponent></headerComponent>
    <div id="body-content" [ngClass]="{'contains-tabs': containsTabs()}">
      <div id="content">
        @if ((message | async) !== null) {
          <notification [timeout]="3000" [severity]="type | async"
          [message]="message | async"></notification>
        }
        <router-outlet></router-outlet>
      </div>
    </div>
    @if (actionInProgress()) {
      <div class="waiter">
        <div></div>
      </div>
    }
  </div>
} @else {
  <login></login>
}
